import { getForecastDate } from "./dateUtils.js";

export const translations = {
  en: {
    title: "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM",
    warningTitle: "Fire Risk Advisory for Timor-Leste",
    advisoryNumber: "Advisory number: ",
    issuedBy: "Issued by:",
    issuedAt: "Date & Time: ",
    overview: "Overview:",
    overviewText: "A forecast has been issued for high fire risk hotspots in several sucos within highRiskMunicipalities. Immediate precautions are recommended to prevent fire outbreaks.",
    tableHeaders: ["Municipality", "Impact", "Probability"],
    observation: "Fire Risk Forecast Date:  ",
    impact: "Impact and Risk Information:",
    ocean: "Significant Wave Height Information:",
    generalAdvisory: "General Advisory:",
    advisoryIntro:
      "The Disaster Risk Reduction Decision Support System advises the following precautions to ensure safety and mitigate Fire Risk risks:",
    advisoryTableHeaders: ["Type", "Advisory"],
    advisoryPoints: [],
    rainfallAlertMap: "Rainfall Alert Forecast for next 3 days:",
    rainfallTableHeaders: [
      [
        {
          content: "Sl No",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipality",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Post Admin",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
        "Rainfall (mm)",
        "Characteristics",
      ],
    ],
    noteLabel: "Note:",
    noteText:
      "The report is valid up to 9 AM UTC [VALID_UP_DATE]. Please monitor the website for additional information and alerts issued by the Department of Meteorology.",
    footer:
      "DISASTER RISK REDUCTION DECISION SUPPORT SYSTEM (DRRDSS), Email: timor-leste@rimes.int, Phone: +670-74520986",
    page: "Page [i] of [pageCount]",
  },
  tetum: {
    title: "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE",
    warningTitle: "Aviso Kona-ba Risku Ahi iha Timor-Leste",
    advisoryNumber: "Númeru Aviso: ",
    issuedBy: "Ema-husik husi: ",
    issuedAt: "Data no Oras: ",
    overview: "Visaun Jeral",
    overviewText: "Hahu previsaun atu mosu fatin boot-risku ahi iha balun suku sira iha munisípiu boot-risku. Precaução urgente rekomenda atu prevene susar ahi.",
    tableHeaders: ["Munisípiu", "Impaktu", "Probabilidade"],
    observation: "Data Previsaun Risku Ahi:",
    impact: "Informasaun Kona-ba Efeitu no Risku:",
    ocean: "Informasaun Kona-ba Altura Signifikante Tasi Fuan:",
    generalAdvisory: "Konsellu Jeral:",
    advisoryIntro:
      "Sistema Apoiu Desizaun Redusaun Risku Dezastre konsella medida prevensaun tuir mai atu garante seguransa no mitiga risku ahi:",
    advisoryTableHeaders: ["Tipu", "Konsellu"],
    advisoryPoints: [],
    rainfallAlertMap: "Previsaun Alerta Udan ba loron 3 ne’ebé mai:",
    rainfallTableHeaders: [
      [
        {
          content: "N°",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Municipio",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Administradór Postu",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "Suco",
          rowSpan: 2,
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: getForecastDate(0),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(1),
          colSpan: 2,
          styles: { halign: "center" },
        },
        {
          content: getForecastDate(2),
          colSpan: 2,
          styles: { halign: "center" },
        },
      ],
      [
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
        "Lluvia (mm)",
        "Características",
      ],
    ],
    noteLabel: "Nota:",
    noteText:
      "Relatóriu ne’e válidu to’o 9 AM UTC [VALID_UP_DATE]. Favor monitoriza website ba informasaun adisional no alerta sira ne’ebé Departamentu Meteorolojia ema-husik.",
    footer:
      "SISTEMA APOIU DESIZAUN REDUSAUN RISKU DEZASTRE (DRRDSS), Email: timor-leste@rimes.int, Telefone: +670-74520986",
    page: "Pajina [i] husi [pageCount]",
  },
};

export const rainfallCharacteristicsTranslations = {
  en: {
    NoRisk: "No-Risk",
    Low: "Low",
    Medium: "Medium",
    High: "High",
    "N/A": "N/A",
  },
  tetum: {
    NoRisk: "La-Risku",
    Low: "Kraik",
    Medium: "Meiu",
    High: "Forte",
    "N/A": "Laiha Dadus",
  },
};

export const characteristicColors = {
  NoRisk: [148, 203, 85],
  Low: [243, 235, 18],
  Medium: [243, 155, 58],
  High: [230, 45, 58],
  "N/A": [222, 222, 223],
};